import Checkbox from '@components/Checkbox';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import usePopupHide from './hooks/usePopupHide';

type Props = Pick<ReturnType<typeof usePopupHide>, 'hide' | 'hideToday' | 'isTodayHidden'>

function BannerFooter({ hideToday, hide, isTodayHidden }:Props) {
    const { t } = useTranslation('main', { keyPrefix: 'popupBanner' });
    return (
        <Footer>
            <TodayDisable>
                <Checkbox isChecked={isTodayHidden}
                    onClick={hideToday} >
                    <Text fontWeight='bold'>
                        {t('closeToday')}
                    </Text>
                </Checkbox>
            </TodayDisable>
            <Close onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                hide();
            }}>
                <Text fontWeight='bold'>
                    {t('close')}
                </Text>
            </Close>
        </Footer>
    );
}

const Footer = styled.footer`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${colors.white};
    width: 100%;
    border-top: 1px solid ${colors.gray3};
    padding-bottom: var(--safe-area-bottom);
`;

const TodayDisable = styled.div`
    padding:  20px;
    flex: 1;
    border-right: 1px solid ${colors.gray3};
`;

const Close = styled.div`
    padding:  20px;
`;

export default BannerFooter;
